if (typeof app === 'undefined') var app = {};

app.cruiseCheckbox = (function () {

    var attrName = 'data-cruise-checkbox';

    function init()
    {
        $('[' + attrName + ']').each( function(){
            var container = $(this);
            if (container.data('init')) return;
            container.data('init', true);

            var checkbox = container.find('.checkbox input');

            if(checkbox.is(":checked")) container.addClass('active');

            checkbox.change(function(){
                if(checkbox.is(":checked")) {
                    container.addClass('active');
                } else {
                    container.removeClass('active');
                }
            });

        });
    }

    return {
        'init': init
    };

})();

$(function () {
    app.cruiseCheckbox.init();
});

